import React from 'react'

import { remove } from '../BankActions'
import GlobalList from '../../components/GlobalList'
import { exportFormatedMoney } from '../../../util/utils'

function createData(id, name, status, agency, account, balance) {
  return {
    id,
    name,
    status,
    agency,
    account,
    balance,
    update: 'update-bank',
    delete: 'delete-bank',
    link_update: `/bank/${id}/edit`,
  }
}

const headCells = [
  {
    id: 'id',
    numeric: false,
    disablePadding: true,
    label: 'ID',
  },
  {
    id: 'name',
    numeric: true,
    disablePadding: false,
    label: 'Nome',
  },
  {
    id: 'status',
    numeric: true,
    disablePadding: false,
    label: 'Status',
  },
  {
    id: 'agency',
    numeric: true,
    disablePadding: false,
    label: 'Agência',
  },
  {
    id: 'account',
    numeric: true,
    disablePadding: false,
    label: 'Conta',
  },
  {
    id: 'balance',
    numeric: true,
    disablePadding: false,
    label: 'Saldo',
  },
  {
    id: 'actions',
    numeric: true,
    disablePadding: false,
    label: 'Ações',
    align: 'center',
  },
]

function List(props) {
  const { items } = props
  const rows = []

  items.map(item => {
    return rows.push(
      createData(
        item.id,
        item.name,
        item.status,
        item.agency,
        item.account,
        exportFormatedMoney(item.balance)
      )
    )
  })

  return (
    <GlobalList
      {...props}
      headCells={headCells}
      rows={rows}
      remove={remove}
      orderField="id"
      renderFirstTH
      moduleKey="bancos"
    />
  )
}

export default List
